import clsx from 'clsx'
import { FormattedText } from '../../../components'
import { ChatContentProps } from './ChatMessageContent'

export function ChatMessageContentInteractive (props: ChatContentProps) {
  const { content, className } = props

  return (
    <div className={clsx(className, 'text-sm px-1')}>
      <div className="text-sm text-gray-400 italic">
        Interactive
      </div>
      <FormattedText text={content} />
    </div>
  )
}
